import { Button } from "@/components/ui/button";
import { useI18n } from "@/i18n";
import { useDownload } from "@/hooks/useDownload";
import { Globe, Loader2 } from "lucide-react";
import { AiFillApple } from "react-icons/ai";
import esthaIcon from "@/assets/estha-icon.png";

const Navbar = () => {
  const { language, setLanguage } = useI18n();
  const { isLoading, downloadLatest } = useDownload();

  return (
    <nav className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-200/50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center gap-2">
            <img src={esthaIcon} alt="Estha" className="w-7 h-7" />
            <span className="text-lg font-semibold text-gray-900">Estha</span>
          </div>

          <div className="flex items-center gap-3">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setLanguage(language === 'en' ? 'zh' : 'en')}
              className="text-gray-600 hover:text-gray-900"
            >
              <Globe className="mr-1.5 h-4 w-4" />
              {language === 'en' ? '中文' : 'English'}
            </Button>

            <Button
              size="sm"
              className="bg-[#1E88C8] hover:bg-[#1670A8] text-white"
              onClick={downloadLatest}
              disabled={isLoading}
            >
              {isLoading ? (
                <Loader2 className="mr-1.5 h-4 w-4 animate-spin" />
              ) : (
                <AiFillApple className="mr-1 h-4 w-4" />
              )}
              {language === 'en' ? 'Download' : '下载'}
            </Button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
